// Suggests a short code for a new Customer/Product Price Group: first 3
// letters of the name, uppercased, with a numeric suffix if that collides
// with a code already in use — e.g. "Dealer" -> DEA, next "Dealer" -> DEA1.
// Max 5 chars (3-letter base + up to a 2-digit suffix). Purely a starting
// suggestion — the field stays freely editable before and after save.
export function suggestShortCode(name, existingCodes) {
  const used = new Set((existingCodes || []).filter(Boolean).map((c) => String(c).toUpperCase()));
  const letters = String(name || '').toUpperCase().replace(/[^A-Z]/g, '');
  const base = letters.slice(0, 3) || 'GRP';

  if (!used.has(base)) return base;

  for (let i = 1; i <= 99; i++) {
    const candidate = `${base}${i}`;
    if (!used.has(candidate)) return candidate;
  }

  return '';
}
